import {
  ACCOUNT_DATA_KEYS,
  ADMIN_ROLE,
  CONSTANTS,
  EMAIL_TEMPLATE_TYPES,
  HEADER_PARSING_STATUS,
  HIGHLIGHTED_TEXTS,
  TEMPLATE_TOKENS
} from "../constants/contants";

// import { defaultSetting } from "../pages/Settings";
import { TagInputTypes } from "../components/atoms/TagInput";
import validator from "validator";
import { max } from "moment";

export interface SettingsData {
  [ACCOUNT_DATA_KEYS.AUTHENTICATED]: boolean;
  [ACCOUNT_DATA_KEYS.ACCOUNT_NAME]: string;
  [ACCOUNT_DATA_KEYS.ACCOUNT_EMAIL]: string;
  [ACCOUNT_DATA_KEYS.LOGIN_AT]: string | number;
  [ACCOUNT_DATA_KEYS.EXPIRE_AT]: string | number;
  [ACCOUNT_DATA_KEYS.DAYS_REMAINING]: string | number;
  [ACCOUNT_DATA_KEYS.LAST_UPDATE]: string | number;
  [ACCOUNT_DATA_KEYS.TOTAL_RULES]: string | number | undefined;
  [ACCOUNT_DATA_KEYS.TOTAL_USED]: string | number | undefined;
}

export const defaultSetting: SettingsData = {
  [ACCOUNT_DATA_KEYS.AUTHENTICATED]: false,
  [ACCOUNT_DATA_KEYS.ACCOUNT_NAME]: '',
  [ACCOUNT_DATA_KEYS.ACCOUNT_EMAIL]: '',
  [ACCOUNT_DATA_KEYS.LOGIN_AT]: 0,
  [ACCOUNT_DATA_KEYS.EXPIRE_AT]: 0,
  [ACCOUNT_DATA_KEYS.DAYS_REMAINING]: '',
  [ACCOUNT_DATA_KEYS.LAST_UPDATE]: '',
  [ACCOUNT_DATA_KEYS.TOTAL_RULES]: 0,
  [ACCOUNT_DATA_KEYS.TOTAL_USED]: 0,
}


export const getIdToken = (tokenName:string='id_token') => {
  // Capture the redirected URL
  var url = window.location.href;
  // Extract id token from the id_token parameter
  var match = url?.match(tokenName+'=([^&]*)');
  if (match) {
    var id_token = match[1]; // String captured by ([^&]*)

    // Make AWS request using the id token
    if (id_token) {
      return id_token
    }else{
      return false
    }
  }else{
    // console.log('Error: There was no id token in the URL');
    return false
  }
}

export const generateDayWiseTimeSeries = (baseval:any, count:any, yrange:any) => {
  let i = 0;
  let series = [];
  while (i < count) {
    let x = baseval;
    let y =
      Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

    series.push([x, y]);
    baseval += 86400000;
    i++;
  }
  return series;
}

export const toPages = (pages: number) =>{
  const results = [];

  for (let i = 1; i <= pages; i++) {
    results.push(i);
  }

  return results;
}


export const setPriorityColor = (priority: string, icon: string) => {
  if (icon === "color") {
    switch (priority) {
      case 'Low':
        return CONSTANTS.PRIORITIES.Low.color;
      case 'High':
        return CONSTANTS.PRIORITIES.High.color;
      case 'Medium':
        return CONSTANTS.PRIORITIES.Medium.color;
    }
  }
  else {
    switch (priority) {
      case 'Low':
        return CONSTANTS.PRIORITIES.Low.linkIcon;
      case 'High':
        return CONSTANTS.PRIORITIES.High.linkIcon;
      case 'Medium':
        return CONSTANTS.PRIORITIES.Medium.linkIcon;

    }
  }
}

export const setCateColor = (cate: string) => {
  switch (cate) {
    case 'Threat':
      return CONSTANTS.CATEGORIES.Threat;
    case 'Clean':
      return CONSTANTS.CATEGORIES.Clean;
    default:
      return CONSTANTS.CATEGORIES.Unknown;
  }
}

export const highlightedText = (type: string) => {
  switch (type) {
    case "enable":
      return HIGHLIGHTED_TEXTS.ENABLE;
    case "expire":
      return HIGHLIGHTED_TEXTS.EXPIRE;
    case "renew":
      return HIGHLIGHTED_TEXTS.RENEW;
    default:
      return HIGHLIGHTED_TEXTS.DISABLE;
  }
}

export const getTemplateTitle = (cate: string) => {
  switch (cate) {
    case 'forward':
      return EMAIL_TEMPLATE_TYPES.FORWARD;
    case 'response':
      return EMAIL_TEMPLATE_TYPES.RESPONSE;
    default:
      return EMAIL_TEMPLATE_TYPES.RESPONSE;
  }
}

export const setStatusColor = (status: string, type: string) => {
  if (type !== 'text') {
    switch (status) {
      case 'Resolved':
        return CONSTANTS.STATUS.Resolved.bgColor;
      case 'In Review':
        return CONSTANTS.STATUS.InReview.bgColor;
      default:
        return CONSTANTS.STATUS.Received.bgColor;
    }
  }
  else {
    switch (status) {
      case 'Resolved':
        return CONSTANTS.STATUS.Resolved.color;
      case 'In Review':
        return CONSTANTS.STATUS.InReview.color;
      default:
        return CONSTANTS.STATUS.Received.color;
    }
  }
}

export const Pluralize = (label:string, len:number) => {
  try {
    return len !== 1 ? label + 's' : label;
  } catch (e) {
    return label
  }
}

export const noUserDataRedirect = () => {
    localStorage.clear();
    let loginLink = "https://" + process.env.REACT_APP_AWS_CONFIG_LOGIN_URL;

    const isLogout = sessionStorage.getItem('isLogout');

    if (isLogout === 'company_admin') {
      loginLink += "/company_admin";
    } else {
      loginLink += "/admin";
    }
    window.location.href = loginLink;
}

export const handleSpinEmailDetailTabs = (pinTabHeaderStyle: any) => {
  const emailDetailElement = document?.getElementById('email-detail')
  if (emailDetailElement){
    let emailDetailTabTitle = emailDetailElement.getElementsByClassName('MuiTabs-root')[0] as HTMLElement
    if(document?.getElementById('root')?.className.includes('menu-opened')) {
      pinTabHeaderStyle['width'] = 'calc(100% - 32px)'
    }else {
      pinTabHeaderStyle['width'] = 'calc(100% - 257px)'
    }

    if (window.scrollY >= 450){
      Object.keys(pinTabHeaderStyle).map((key:string) => {
        emailDetailTabTitle.style[key] = pinTabHeaderStyle[key]
      })
    }else {
      Object.keys(pinTabHeaderStyle).map((key:string) => {
        emailDetailTabTitle.style[key] = 'revert'
      })
    }
  }
}



export const checkStatus = (status: string) => {
  switch (status) {
    case HEADER_PARSING_STATUS.PASS:
      return 'pass';
    case HEADER_PARSING_STATUS.FAIL:
    case HEADER_PARSING_STATUS.SOFTFAIL:
    case HEADER_PARSING_STATUS.NEUTRAL:
    case HEADER_PARSING_STATUS.PERMERROR:
    case HEADER_PARSING_STATUS.TEMPERROR:
    case HEADER_PARSING_STATUS.NONE:
    case HEADER_PARSING_STATUS.MISSING:
      return 'fail';
    default:
      return null
  }
}
/**
 * Safely gets a nested property from an object.
 * @param obj - The object to query.
 * @param path - The path of the property to get.
 * @param defaultValue - The value returned if the property is not found.
 * @returns The value of the nested property or the default value.
 */
export function getNestedProperty<T>(obj: T, path: (string | number)[], defaultValue: any): any {
    return path.reduce((acc, key) => (acc && acc[key as keyof typeof acc] !== undefined ? acc[key as keyof typeof acc] : defaultValue), obj);
}

interface IUserData {
  id: string;
  email: string;
  name: string;
  role: string;
}

export const getUserData = () => {
  const defaultData: IUserData = {
    id: '',
    email: '',
    name: '',
    role: '',
  }
  const userLocalData = localStorage.getItem('userData') || '{}';
  const { userId: id, email, fullName: name, role } = JSON.parse(userLocalData ?? JSON.stringify(defaultData));

  return {
    id,
    email,
    name,
    role,
  }
}

type AlertLevel = '' | 'warning' | 'error';
const getAlertLevel = (
  daysRemaining: number | string,
  isActive = false,
  warningThreshold = 15
): AlertLevel => {
  if (daysRemaining === '') return '';
  if (daysRemaining <= 0 && isActive) return 'error';
  if (daysRemaining <= warningThreshold && isActive) return 'warning';
  return '';
};

export const determineCredentialsStatus = (tenantData: any, accountsData: any) => {
// Helper function to get days remaining with fallback
  const getAccountDataByKey = (key: ACCOUNT_DATA_KEYS, dataKey = ACCOUNT_DATA_KEYS.DAYS_REMAINING) =>
    accountsData[key]?.[dataKey] ?? defaultSetting[dataKey];

  // Destructure tenant data with defaults
  const {
    phishClear = false,
    blocklist = false,
    automationPhishClear = false,
    automationBlocklist = false
  } = tenantData ?? {};

  // Get all days remaining values
  const daysRemaining = {
    autoPhishClear: getAccountDataByKey(ACCOUNT_DATA_KEYS.AUTO_PHISH_CLEAR),
    autoBlockList: getAccountDataByKey(ACCOUNT_DATA_KEYS.AUTO_BLOCK_LIST),
    phishClear: getAccountDataByKey(ACCOUNT_DATA_KEYS.PHISH_CLEAR),
    blockList: getAccountDataByKey(ACCOUNT_DATA_KEYS.BLOCK_LIST),
  };

  // Calculate all alert levels
  return {
    autoPhishClear: getAlertLevel(daysRemaining.autoPhishClear, automationPhishClear),
    autoBlockList: getAlertLevel(daysRemaining.autoBlockList, automationBlocklist),
    phishClear: getAlertLevel(daysRemaining.phishClear, phishClear),
    blockList: getAlertLevel(daysRemaining.blockList, blocklist),
  };
};

export const isNullOrEmpty = (value: any)=> {
  return value == null || (typeof value === 'string' && value.trim().length === 0);
}

export const getTimeZoneName = () => {
  let tz_name = 'Etc/UTC';
  const localStorageUserData = localStorage.getItem('userData');
  if(localStorageUserData) {
    const parseUserData = JSON.parse(localStorageUserData)
    tz_name = parseUserData["tz_name"]
  }

  return tz_name
}

export const handleDisplayForLargeNumber = (displayNumber: number): string => {
  if(displayNumber < 1000){
    return displayNumber.toString()
  }

  let result = ""
  let splittedTempArr = displayNumber.toString().split("").reverse()
  for(let i = 0; i < splittedTempArr.length; i++){
    if(i === 0 || i+1 === splittedTempArr.length){
      result += splittedTempArr[i]
      continue
    }
    result += (i+1)%3 === 0 ? `${splittedTempArr[i]},` : splittedTempArr[i]
  }
  return result.split("").reverse().join("")
}

export const handleMonthName = (monthNumber: number) => {
  const date = new Date();
  date.setMonth(monthNumber-1);

  return date.toLocaleString('en-US', { month: 'long' });
}

export const autoDownload = (url: string) => {
  const filename = url.split('/').pop() || 'download';
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}


export const isTemplateToken = (value: string) => Object.values<string>(TEMPLATE_TOKENS).includes(value);

export const insertTextAtCursor = (element: any, textToInsert: string) => {
  // Focus the element first to ensure selection properties are available
  element.focus();

  const startPos = element.selectionStart || 0;
  const endPos = element.selectionEnd || 0;
  const currentValue = element.value || '';

  // Insert the text at cursor position
  element.value = currentValue.substring(0, startPos) + textToInsert + currentValue.substring(endPos, currentValue.length);

  // Set the new cursor position
  const newPosition = startPos + textToInsert.length;
  element.selectionStart = newPosition;
  element.selectionEnd = newPosition;

  // Trigger input event for React/state management
  element.dispatchEvent(new Event('input', { bubbles: true }));
}
export const isAdmin = JSON.parse(sessionStorage.getItem('userData') || localStorage.getItem('userData') || '{}')['role'] === ADMIN_ROLE;

export const validateRequiredMax = (
    v: unknown,
    max: number,
    field = 'Field',
    t?: any
) => {
    const s = (v ?? '').toString().trim();
    if (s === '') return t ? t('validation.required', { field }) : `${field} is required.`;
    // @ts-ignore
    return [...s].length <= max
        ? ''
        : t
            ? t('validation.maxLength', { field, max })
            : `${field} must be ≤ ${max} characters.`;
};

const EMAIL_TAG_TYPES = [TagInputTypes.TO, TagInputTypes.FROM, TagInputTypes.CC, TagInputTypes.EMAIL];
const DOMAIN_TAG_TYPES = [TagInputTypes.DOMAIN, TagInputTypes.DNS, TagInputTypes.SENDER_DOMAIN];
export const isValidTagValue = (type = '', lowercaseInputValue = '', emptyValueIsValid = false) => {
  const trimmedValue = lowercaseInputValue.trim();
  if (!trimmedValue) {
    return emptyValueIsValid;
  } else {
    if (validator.isIn(type, EMAIL_TAG_TYPES)) {
      const wildcardCount = (trimmedValue.match(/\*/g) || []).length;
      if (wildcardCount > 1) return false;
      const normalized = trimmedValue.replace(/\*/g, 'a');
      return (validator.isEmail(normalized, { validate_length: false } as validator.IsEmailOptions) || trimmedValue === TEMPLATE_TOKENS.SENDER);
    } else if (validator.isIn(type, DOMAIN_TAG_TYPES)) {
      const wildcardCount = (trimmedValue.match(/\*/g) || []).length;
      const maxWildcard = Number(type === TagInputTypes.DOMAIN || type === TagInputTypes.SENDER_DOMAIN);
      if (wildcardCount > maxWildcard) return false;
      const normalized = trimmedValue.replace(/\*/g, 'a');
      return validator.isFQDN(normalized, {
        require_tld: true,
        allow_underscores: false,
        validate_length: false,
      } as validator.IsFQDNOptions);
    } else if (type === TagInputTypes.URL) {
      const wildcardCount = (trimmedValue.match(/\*/g) || []).length;
      if (wildcardCount > 1) return false;
      const normalized = trimmedValue.replace(/\*/g, 'a');
      return validator.isURL(normalized, {
        protocols: ['http', 'https', 'ftp'],
        require_protocol: true,
        allow_underscores: true,
        allow_fragments: true,
        allow_query_components: true,
        disallow_auth: true,
        validate_length: false,
      } as validator.IsURLOptions);
    } else if (type === TagInputTypes.IP) {
      return validator.isIP(trimmedValue);
    } else if (type === TagInputTypes.FILEHASH) {
      return validator.isHash(trimmedValue, 'sha256') || validator.isHash(trimmedValue, 'sha512') || validator.isHash(trimmedValue, 'md5');
    }
  }
};


export const isEditorContentEmpty = (value: string) => {
  if (!value) return true; // Handle null/undefined

  // Remove HTML tags
  let cleaned = value.replace(/<[^>]*>/g, "");
  // Remove &nbsp; and normal whitespace
  cleaned = cleaned.replace(/&nbsp;|\s+/g, "");

  return cleaned.length === 0;
};

/**
 * One function to truncate any text.
 * - Default: cut in the middle (good for URL, long IDs): "start…end"
 * - If you want end-cut: mode="end"
 */
export function truncateText(
    input: unknown,
    maxLen: number = 100,
    mode: "middle" | "end" = "end",
    ellipsis = "…",
    keepStart = 0,
    keepEnd = 0
): string {
  try {
    const text = (typeof input === "string" ? input : String(input ?? "")).trim();

    if (maxLen <= 0) return "";
    if (text.length <= maxLen) return text;

    if (ellipsis.length >= maxLen) return ellipsis.slice(0, maxLen);

    const room = maxLen - ellipsis.length;

    if (mode === "end") {
      return text.slice(0, maxLen) + ellipsis;
    }

    // mode === "middle"
    // Ensure we keep at least 1 char on each side.
    let startLen = Math.max(1, Math.min(keepStart, room - 1));
    let endLen = Math.max(1, Math.min(keepEnd, room - startLen));

    // Balance remaining room if any.
    const kept = startLen + endLen;
    const extra = room - kept;
    if (extra > 0) {
      startLen += Math.floor(extra / 2);
      endLen += extra - Math.floor(extra / 2);
    }

    return text.slice(0, startLen) + ellipsis + text.slice(text.length - endLen);
  } catch {
    return "";
  }
}